module.exports = __webpack_public_path__ + "static/media/icon-screen-share.781bce3f.svg";